import { useState, useEffect } from 'react';
import Template from './components/templates'
import './App.css';
import Meme from './components/meme';

function App() {
  const [templates, setTemplates] = useState([]);
  const [meme, setMeme] = useState(null);
  useEffect(() =>{
    fetch("https://api.imgflip.com/get_memes")
    .then((res) => res.json())
    .then((data) => {
      setTemplates(data.data.memes);
    })
  }, []);
  return (
    <div className="App">
      <h1 className="
        antialiased 
        text-3xl
        text-center
        m-8">Meme Generator</h1>
      {meme === null ? (
        <Template templates = {templates} setMeme={setMeme}/>
      ) : (
        <Meme meme={meme} setMeme={setMeme} />
      ) }
      
    </div>
  );
}

export default App;
